<template>
  <div class="wrapper mt-3">
    <h4>Business Flow</h4>
    <div class="row mb-3">
      <div class="col-md">
        <div role="toolbar" class="btn-toolbar d-flex justify-content-between">
          <div class="btn-group mr-3">
            <button @click="saveFlow()" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
          </div>
          <div class="form-inline">
            <label>Flow-Name:</label>
            <input type="text" class="ml-2 form-control" v-model="bflow.name"/>
          </div>
          <button @click="executeFlow" class="btn btn-secondary"><font-awesome-icon icon="play"/>&nbsp;Ausführen</button>
        </div>
      </div>
      <div class="col-md">
      </div>
    </div>

    <!-- flow -->
    <div class="row m-2">
      <div class="col-md ml-2">
        <FlowEditor @selectNode="showNode" @selectEdge="showEdge" ref="floweditor" :elements="elemGroups"/>
      </div>
      <div class="col-xs" style="min-width:350px;">
        <BFlowStartProps @update="updateNode" :node="editData" v-if="editNode && editData.type=='start'"/>
        <BFlowTaskProps ref="task" @reqvars="getVariables" @update="updateNode" :serviceRegistry="serviceRegistry" :serviceDataTypes="serviceDataTypes" :scripts="scriptNames" :variables="variables" :tables="tableList" :node="editData" v-else-if="editNode && editData.type!=='start'"/>
        <BFlowEdgeProps @update="updateEdge" :edge="editData" v-else-if="editEdge"/>
        <div v-else class="card" style="max-width:340px;margin-left:20px;">
          <h5 class="card-title">Eigenschaften</h5>
          <div class="card-body">
            <p>Knoten auswählen</p>
            <p>(doppel Klick)</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scripttasks from '@/modules/scripttasks.js'
import remoteservices from '@/modules/remoteservices.js'
import datamap from '@/modules/datamap.js'
import bflows from '@/modules/bflows.js'
import BFlowStartProps from '@/components/digitalfirm/BFlowStartProps.vue'
import BFlowTaskProps from '@/components/digitalfirm/BFlowTaskProps.vue'
import BFlowEdgeProps from '@/components/digitalfirm/BFlowEdgeProps.vue'
import FlowEditor from '@/components/flows/FlowEditor.vue'

export default {
  name: 'BFlowEditor',
  components: {
    BFlowStartProps,
    BFlowTaskProps,
    BFlowEdgeProps,
    FlowEditor,
  },
  data() {
    return {
      refreshcount: 0,
      bflow: {},
      serviceRegistry: {},
      serviceDataTypes: {},
      nodes: [],
      variables: {"datasource":{},"outputs":{}},
      connections: [],
      node_save: [],
      con_save: [],
      editNode: false,
      editData: {},
      scriptNames: [],
      tableList: [],
      editEdge: false,
      varUpdate: false,
      elemGroups: [
        {
          title: 'Programm',
          name: 'program'
        },
        {
          title: 'Daten',
          name: 'data'
        },
      ]
    }
  },
  mounted: function() {
    var self = this;

    this.$nextTick(function() {

      self.initElements();
      console.log('init elemens done');

      // load modules registry
      remoteservices.registry().then(function(data) {
        self.serviceRegistry = data;
      }).catch (err => {
        console.error(err);
      });

      remoteservices.datatypes().then(function(data) {
        self.serviceDataTypes = data;
      }).catch (err => {
        console.error(err);
      });

      // load available script tasks
      scripttasks.list(this,-1,function(data) {
        self.scriptNames = data;
      })

      // load available tables first rows
      datamap.listtables(this,0,100,'name','',function(data) {
        for (var i=0;i<data.length;i++) self.tableList.push(data[i].name);
        console.log(self.tableList);
      });

      // check to load model from backend
      if (this.$route.params.flowid && this.$route.params.flowid !== 'new') {
        bflows.load(this,this.$route.params.flowid,function(data) {
          self.bflow = data;

          // convert from flownet to vue flow chart
          self.bflow.flownet.nodes.forEach(n => {
            console.log('add : ', n);
            var node = self.$refs.floweditor.addNode({ shape: n.type, id: n.id, label: n.name, x: n.x, y: n.y,
              attrs: {
                ftype: n.type,
                flowprops: n || {},
              },
            });
            node.setData(n || {});
          }); // add nodes

          self.bflow.flownet.edges.forEach(e => {
            var ge = self.$refs.floweditor.addEdge({
              source: { cell: e.source, port: e.sourcePort },
              target: { cell: e.target, port: e.targetPort },
              vertices: e.vertices
            });
            ge.setData(e);
          }) // add edges

        }) // load flow
      } // if not new

    });

  },
  methods: {

    showEdge: function(edge) {
      this.editEdge = edge.edge;
      this.editNode = false;
      this.editData = this.editEdge.getData() || {};
    },

    getScript(id) {
      if (this.scriptNames) {
        for (var i=0;i<this.scriptNames.length;i++) {
            if (this.scriptNames[i].id == id) return JSON.parse(JSON.stringify(this.scriptNames[i]));
        }
      }
      var self = this;
      scripttasks.load(this,id,function(data) {
        self.scriptNames.push(data);
      });
      return false;
    },

    getVariables(nodeid) {
      console.log('get variables ' + nodeid);
      var variables = {"datasource":{},"outputs":{}};

      if (!nodeid) return;

      var node  = this.$refs.floweditor.graph.model.getCell(nodeid);
      var nodes = this.$refs.floweditor.graph.model.getPredecessors(node);

      for (var i=0;i<nodes.length;i++) {
        var entry = nodes[i].getData();
        // check variables from script node
        if (!entry) continue;
        if (entry.class == 'script') {
          var sv = this.getScript(entry.script);
          if (sv) {
            if (sv.output)
              variables.outputs[entry.name] = sv.output;
          } else if (this.refreshcount < 3){
            this.refreshcount++;
          }
        // check service variables
        } else if (entry.class == 'remoteservice') {
            var service = false;
            if (entry.serviceKey) service = this.serviceRegistry[entry.serviceKey];
            if (service) service = service[entry.controller];
            if (service) service = service[entry.method];
            if (service && service.output) {
              variables.outputs[entry.name] = service.output;
            }
        // variable for data nodes
        } else if (entry.class == 'data' || entry.class == 'datafilter' || entry.class == 'datasort') {
          variables.datasource[entry.name] = { "name":entry.name };
        }
      }

      this.variables = variables;

    },

    // open node properties
    showNode: function(node) {
      console.log('show node',node.node.attrs);
      this.editNode = node.node;

      var temp      = this.editNode.getData() || node.node.attrs.flowprops;
      console.log('TEMP',temp);
      temp.id       = temp.id || node.node.id;
      temp.inputs   = node.node.attrs.flowprops.inputs || {};
      this.editData = temp;

      console.log(this.editData);

      this.editEdge = false;

    },

    // execute the current flow
    executeFlow: function() {
      if (confirm('Möchten Sie Flow wirklich ausführen, ist er aktuell gespeichert?')) {
        var self = this;
        bflows.execute(this,this.bflow.id,{},function() {
          self.$bvToast.toast('Flow wurde gestartet.',{title:'BusinessFlows',variant:'success'});
        })
      }
    },

    updateNode() {
      if (this.editNode) {
        this.editNode.setData(this.editData);
        this.editNode.setLabel(this.editData.name);
      }
    },

    updateEdge() {
      if (this.editEdge) {
        this.editEdge.setData(this.editData);
      }
    },

    // save the flow chart to flownet config
    saveFlow: function() {

      if (this.bflow.name === "") {
        this.$bvToast.toast('Bitte erst einen Namen für den Flow eingeben.',{title:'Speichern',variant:"warning"});
        return;
      }

      // update internal data

      var update = { nodes: [], edges: [] };

      var nodes = this.$refs.floweditor.getNodes();
      for (var i in nodes) {
        var node  = nodes[i];
        var pos   = node.position();
        var ndata = node.getData() || node.attrs.flowprops;

        if (ndata.type == 'start') ndata.start = true;

        ndata.id    = node.id;
        ndata.x     = pos.x;
        ndata.y     = pos.y;

        //update.nodes.push({id: node.id, x: pos.x, y: pos.y, name: node.getLabel(), data: node.getData() });
        update.nodes.push(ndata);
      }

      var edges = this.$refs.floweditor.getEdges();
      for (i in edges) {
        var edge = edges[i];
        var entry = { id: edge.id, source: edge.source.cell, target: edge.target.cell , vertices: edge.vertices };
        var data = edge.getData();
        if (data && data.cond) entry.cond = data.cond;
        if (data && data.name) entry.name = data.name;
        update.edges.push(entry);
      }


      this.bflow.flownet = update;
      var self = this;
      bflows.save(this,this.bflow,function(data) {
        self.bflow.id = data.id;
        self.$bvToast.toast("Flow wurde gespeichert.",{title: 'BusinessFlows',variant:"success"});
      });
    },

    initElements() {
      this.$refs.floweditor.registerNode('start',
        {
          inherit: 'rect',
          width: 110,
          height: 60,
          attrs: {
            ftype: 'start',
            flowprops: { name: 'Start' , type: 'start', class: 'eventstart', start: true },
            body: {
              strokeWidth: 2,
              stroke: '#262626',
              fill: '#43aa8b',
              rx: 10,
              ry: 10,
            },
            text: {
              fontSize: 14,
              color: '#262626',
            },
          },
        }, true);

        this.$refs.floweditor.registerNode('Script',
          {
            inherit: 'rect',
            width: 110,
            height: 60,
            attrs: {
              ftype: 'Script',
              flowprops: { name: 'Script' , type: 'Script' , class: 'script' },
              body: {
                strokeWidth: 2,
                stroke: '#262626',
                fill: '#577590',
                rx: 10,
                ry: 10,
              },
              text: {
                fontSize: 14,
                color: '#262626',
              },
            },
          }, true);

          this.$refs.floweditor.registerNode('RemoteService',
            {
              inherit: 'rect',
              width: 110,
              height: 60,
              attrs: {
                ftype: 'RemoteService',
                flowprops: { name: 'Service' , type: 'RemoteService' , class: 'remoteservice' },
                body: {
                  strokeWidth: 2,
                  stroke: '#262626',
                  fill: '#34abeb',
                  rx: 10,
                  ry: 10,
                },
                text: {
                  fontSize: 14,
                  color: '#262626',
                },
              },
            }, true);

          this.$refs.floweditor.registerNode('Data',
            {
              inherit: 'rect',
              width: 110,
              height: 60,
              attrs: {
                ftype: 'Data',
                flowprops: { name: 'Datenquelle',type: 'Data', class: 'data' },
                body: {
                  strokeWidth: 2,
                  stroke: '#262626',
                  fill: '#90be6d',
                  rx: 10,
                  ry: 10,
                },
                text: {
                  fontSize: 14,
                  color: '#262626',
                },
              },
            }, true);

            this.$refs.floweditor.registerNode('Export',
              {
                inherit: 'rect',
                width: 110,
                height: 60,
                attrs: {
                  ftype: 'Export',
                  flowprops: { name: 'Datenexport',type: 'Export' , class: 'dataexport' },
                  body: {
                    strokeWidth: 2,
                    stroke: '#262626',
                    fill: '#f9c74f',
                    rx: 10,
                    ry: 10,
                  },
                  text: {
                    fontSize: 14,
                    color: '#262626',
                  },
                },
              }, true);

              this.$refs.floweditor.registerNode('DataFilter',
                {
                  inherit: 'rect',
                  width: 110,
                  height: 60,
                  attrs: {
                    ftype: 'DataFilter',
                    flowprops: { name: 'Filtern',type: 'DataFilter', class: 'datafilter' },
                    body: {
                      strokeWidth: 2,
                      stroke: '#262626',
                      fill: '#f3722c',
                      rx: 10,
                      ry: 10
                    },
                    text: {
                      fontSize: 14,
                      color: '#262626',
                    },
                  },
                }, true);

                this.$refs.floweditor.registerNode('sort',
                  {
                    inherit: 'rect',
                    width: 110,
                    height: 60,
                    attrs: {
                      ftype: 'sort',
                      flowprops: { name: 'Sortieren', type: 'sort', class: 'datasort' },
                      body: {
                        strokeWidth: 2,
                        stroke: '#262626',
                        fill: '#f94144',
                        rx: 10,
                        ry: 10,
                      },
                      text: {
                        fontSize: 14,
                        color: '#262626',
                      },
                    },
                  }, true);


        const start = this.$refs.floweditor.createNode({
          shape: 'start', label: 'Start',
          attrs: {
            body: { rx: 10, ry: 10 }
          }
        });

        const script = this.$refs.floweditor.createNode({
          shape: 'Script', label: 'ScriptNode',
          attrs: {
            body: { rx: 10, ry: 10 }
          }
        });

        const rservice = this.$refs.floweditor.createNode({
          shape: 'RemoteService', label: 'Service',
          attrs: {
            body: { rx: 10, ry: 10 }
          }
        })

        const dsource = this.$refs.floweditor.createNode({
          shape: 'Data', label: 'Datenquelle',
          attrs: {
            body: { rx: 10, ry: 10 }
          }
        });

        const dexport = this.$refs.floweditor.createNode({
          shape: 'Export', label: 'Datenexport',
          attrs: {
            body: { rx: 10, ry: 10 }
          }
        });

        const dfilter = this.$refs.floweditor.createNode({
          shape: 'DataFilter', label: 'Filtern',
          attrs: {
            body: { rx: 10, ry: 10 }
          }
        });

        const dsort = this.$refs.floweditor.createNode({
          shape: 'sort', label: 'Sortieren',
          attrs: {
            body: { rx: 10, ry: 10 }
          }
        });

        this.$refs.floweditor.fillElementGroup([start,script,rservice],'program');
        this.$refs.floweditor.fillElementGroup([dsource,dexport,dfilter,dsort],'data');

    }
  }
}
</script>

<style>
.eventstart {
  fill: #0c5;
}
.title: {
  fill: #0cc;
}
.scripttask {
  fill: #0cc;
}
</style>
